import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'
import { Card as CardBase } from '@chilecompra/react-kit/components'

export const Root = styled('div')`
  width: 100%;
`

export const Content = styled(ContainerBase)`
  &.MuiContainer-root {
    width: 100%;
  }
`

export const GridContainer = styled(({ margin, minHeight, padding, pointEvents, userSelect, ...props }) => (
  <GridBase container {...props} />
))`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    min-height: ${props => props.minHeight};
    padding: ${props => props.padding};
  }

  &.MuiGrid-container * {
    point-events: ${props => props.pointEvents};
    user-select: ${props => props.userSelect};
  }
`

export const GridItem = styled(({ margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Form = styled('form')`
  display: block;
  position: relative;
`

export const Card = styled(({ cursor, margin, minHeight, maxWidth, textAlign, ...props }) => <CardBase {...props} />)`
  &.MuiPaper-root {
    box-shadow: rgb(118 138 162 / 20%) 0 4px 10px;
    cursor: ${props => props.cursor};
    margin: ${props => props.margin};
    min-height: ${props => props.minHeight};
    max-width: ${props => props.maxWidth};
    text-align: ${props => props.textAlign};
  }
`

export const SectionHeaderContainer = styled('section')`
  background-color: ${props => props.theme.palette.blue[20]};
  display: flex;
  height: ${props => props.height};
  margin: ${props => props.margin};
  width: 100%;
`

export const HeaderText = styled('p')`
  color: #80b1ff;
  font-weight: 700;
  font-size: 18px;
  margin: ${props => props.margin};
  line-height: 21px;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.blue[75]};
`
